import { useState } from "react";
import { subscriptionService, taskService } from "@miplatform/api";
import {
  ASSIGNMENT_TEMPLATE_TYPES,
  HTTP_STATUSES,
} from "@miplatform/constants";
import { useComponentState, useRouter } from "@miplatform/hooks";

export const useManageOrderTemplateViewModel = () => {
  const [isAddModalVisible, setIsAddModalVisible] = useState(false);
  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false);
  const [selectedWorkOrderTemplate, setSelectedOrderTemplate] = useState({});
  const [workOrderTemplates, setWorkOrderTemplates] = useState([]);
  const [trades, setTrades] = useState([]);

  const stateManager = useComponentState();

  const { navigate } = useRouter();

  const loadWorkOrderTemplates = () => {
    stateManager.run(async () => {
      const response = await taskService.workOrderTemplates.getAll({
        sort: "name asc",
      });

      if (response.status === HTTP_STATUSES.OK) {
        setWorkOrderTemplates(
          response.data.map((orderType, index) => ({ ...orderType, index }))
        );
      }
    });
  };

  const toggleAddModal = () => {
    setIsAddModalVisible((prev) => !prev);
  };

  const handleAddWorkOrderTemplate = (data) => {
    stateManager.run(async () => {
      const { name } = data;
      const { status, data: { id } = {} } =
        await taskService.workOrderTemplates.create({
          data: { ...data, type: ASSIGNMENT_TEMPLATE_TYPES.INSTALL },
          toastMessageConfig: {
            success: {
              text: `${name} was created.`,
            },
          },
        });

      if (status === HTTP_STATUSES.OK) {
        toggleAddModal();
        navigate(`/settings/order-management/work-order-types/${id}/details`);
      }
    });
  };

  const closeDeleteModal = () => {
    setIsDeleteModalVisible(false);
  };

  const openDeleteModal = (orderType) => () => {
    setIsDeleteModalVisible(true);
    setSelectedOrderTemplate(orderType);
  };

  const onDelete = () => {
    stateManager.run(async () => {
      const { id, name, modifiedOn } = selectedWorkOrderTemplate;
      const { status } = await taskService.workOrderTemplates.delete({
        id,
        modifiedOn,
        toastMessageConfig: {
          success: {
            text: `${name} was deleted.`,
          },
        },
      });

      if (status === HTTP_STATUSES.OK) {
        loadWorkOrderTemplates();
        closeDeleteModal();
      }
    });
  };
  const getTrades = () => {
    stateManager.run(async () => {
      const response = await subscriptionService.trades.getAll();
      if (response.status === HTTP_STATUSES.OK) {
        const updatedTrades = response.data.map(({ name, id }) => ({
          label: name,
          value: id,
        }));

        setTrades(updatedTrades);
      }
    });
  };

  return {
    workOrderTemplates,
    trades,
    isAddModalVisible,
    isLoading: stateManager.isBusy(),
    isDeleteModalVisible,
    selectedWorkOrderTemplate,
    loadWorkOrderTemplates,
    handleAddWorkOrderTemplate,
    toggleAddModal,
    openDeleteModal,
    onDelete,
    closeDeleteModal,
    getTrades,
  };
};
